import React from "react";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { motion } from "framer-motion";
import { useInView, STAGGER, FADE_LEFT, FADE_RIGHT } from "../animationUtils";

export const fragments = graphql`
  fragment Homepage_Logos on PrismicHomepageDataBodyLogos {
    id
    slice_type
    items {
      logos_stripe {
        url
      }
    }
    primary {
      logos_quote_author {
        text
      }
      logos_quote_text {
        text
      }
      logos_quote_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, height: 450, width: 450)
      }
    }
  }
  fragment Page_Logos on PrismicPageDataBodyLogos {
    id
    slice_type
    items {
      logos_stripe {
        url
      }
    }
    primary {
      logos_quote_author {
        text
      }
      logos_quote_text {
        text
      }
      logos_quote_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, height: 450, width: 400)
      }
    }
  }
  fragment FocusArea_Logos on PrismicFocusAreaDataBodyLogos {
    id
    slice_type
    items {
      logos_stripe {
        url
      }
    }
    primary {
      logos_quote_author {
        text
      }
      logos_quote_text {
        text
      }
      logos_quote_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, height: 450, width: 450)
      }
    }
  }
`;

function Logos({ data }) {
  const [ref, inView] = useInView();
  const text = data?.primary?.logos_quote_text?.text;
  const author = data?.primary?.logos_quote_author?.text?.split("/");

  return (
    <motion.div
      ref={ref}
      {...STAGGER}
      {...(inView ? { animate: "start" } : {})}
      className="mt-4"
    >
      <div className="slices-logos">
        <div className="slices-logos__img">
          <motion.div {...FADE_LEFT}>
            {data?.primary?.logos_quote_image && (
              <GatsbyImage
                image={data?.primary?.logos_quote_image?.gatsbyImageData}
                alt={data?.primary?.logos_quote_image?.alt}
                objectFit="contain"
              />
            )}
          </motion.div>
        </div>
        <div className="slices-logos__text">
          <motion.h2 {...FADE_RIGHT} className="h4 slices-logos__title">
            {text}
          </motion.h2>
          <motion.h3 {...FADE_RIGHT} className="h10 slices-logos__author">
            {author?.[0]?.trim()} / {author?.[1]?.trim()}
            {author?.[2] && (
              <>
                {" "}
                / <strong>{author?.[2]}</strong>
              </>
            )}
          </motion.h3>
        </div>
      </div>
      <div className="slices-logos__wrapper">
        {data?.items?.map((logo, idx) => {
          if (!logo?.logos_stripe?.url) return null;
          return (
            <div
              key={idx}
              className="slices-logos__background"
              style={{ backgroundImage: `url(${logo?.logos_stripe?.url})` }}
            ></div>
          );
        })}
      </div>
    </motion.div>
  );
}

export default Logos;
